import { useMsal } from '@azure/msal-react'

import { useUserQuery } from 'queries/useUserQuery'

export interface UserData {
  email: string
  firstName: string
  lastName: string
}

export function useGetUserData(): UserData {
  const { accounts } = useMsal()
  const { data: userProfile } = useUserQuery()

  const account = accounts[0]

  return {
    email: userProfile?.email ?? account?.username ?? '',
    firstName: `${userProfile?.firstName}`.trim() || '',
    lastName: `${userProfile?.lastName}`.trim() || '',
  }
}
